import { render, staticRenderFns } from "./sin-membresia.vue?vue&type=template&id=34f77127&"
import script from "./sin-membresia.vue?vue&type=script&lang=js&"
export * from "./sin-membresia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports